import { INote, INoteShared } from '../../types';

export default {
  currentitem: (state: any) => state.notesReducer.noteselected,
  isminimized: (state: any) => state ? state.notesReducer.minimized : false  as boolean,
  inspect: (state: any) => state ? state.notesReducer.inspect : {}  as (INote | INoteShared),  
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/selectors.tsx